import { TOKEN_KEY } from '../constants';

export const getStoredAuthToken = () => localStorage.getItem(TOKEN_KEY);

export const storeAuthToken = (token: string) =>
  localStorage.setItem(TOKEN_KEY, token);

export const removeStoredAuthToken = () => localStorage.removeItem(TOKEN_KEY);
